import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderTestimonial() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 90,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >


               
                    <SwiperSlide>
                        <div className="owl-item cloned" >
                            <div className="testimonial-block_one">
                                <div className="testimonial-block_one-inner">
                                    <div className="testimonial-block_one-author">
                                        <img src="assets/img/3135715.png" alt />
                                        <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                    </div>
                                    <div className="testimonial-block_one-content">
                                        
                                        <div className="testimonial-block_one-designation">Patient</div>
                                        <h3 className="testimonial-block_one-heading" style={{fontSize:"14px"}}>Miss. Prapti Singh</h3>
                                    </div>
                                    <div className="testimonial-block_one-text">Satna Swastik Hospital is itself lovely and also clearly designed to facilitate patient comfort and care,Best hospitality in Vindhya region .</div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="owl-item cloned" >
                            <div className="testimonial-block_one">
                                <div className="testimonial-block_one-inner">
                                    <div className="testimonial-block_one-author">
                                        <img src="assets/img/3135715.png" alt />
                                        <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                    </div>
                                    <div className="testimonial-block_one-content">
                                        
                                        <div className="testimonial-block_one-designation">Patient</div>
                                        <h3 className="testimonial-block_one-heading" style={{fontSize:"14px"}}>Mr. Ashish Parihar</h3>
                                    </div>
                                    <div className="testimonial-block_one-text">Thank you to all the doctors and nurses for making me feel safe, pain free and cared for. Great job done from checking to checking out</div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="owl-item cloned" >
                            <div className="testimonial-block_one">
                                <div className="testimonial-block_one-inner">
                                    <div className="testimonial-block_one-author">
                                        <img src="assets/img/3135715.png" alt />
                                        <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                    </div>
                                    <div className="testimonial-block_one-content">
                                        
                                        <div className="testimonial-block_one-designation">Patient</div>
                                        <h3 className="testimonial-block_one-heading" style={{fontSize:"14px"}}>Mr. Arjun Kumar</h3>
                                    </div>
                                    <div className="testimonial-block_one-text">I will recommend Satna Swastik Hospital to family and friends. Thank you for making me feel like I was got the best care .</div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="owl-item cloned" >
                            <div className="testimonial-block_one">
                                <div className="testimonial-block_one-inner">
                                    <div className="testimonial-block_one-author">
                                        <img src="assets/img/3135715.png" alt />
                                        <span className="testimonial-block_one-quote fa-solid fa-quote-left fa-fw" />
                                    </div>
                                    <div className="testimonial-block_one-content">
                                        
                                        <div className="testimonial-block_one-designation">Patient</div>
                                        <h3 className="testimonial-block_one-heading" style={{fontSize:"14px"}}>Mr. Devesh Shukla</h3>
                                    </div>
                                    <div className="testimonial-block_one-text">I would want to convey my heartfelt gratitude for my wife's timely and expert treatment. This institution provided us with one of the fastest and greatest experiences we have ever had.</div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    

            </Swiper>
        </>
    );
}
